import React, {Component} from 'react';
import './Dialogs.min.css';

export class ExportDialog_1 extends Component {
    constructor(props) {
        super(props);
    }
    validateInput() {
        var checked = document.querySelector('input[name = "export_grp"]:checked');
        if(checked){
            //console.log(this.props.customer);
            var url = this.props.urlDW2 + "/Integration?run=MTS_244_Sales&Transition=ExportCad&ExportFileType=" + checked.value;

            var customer = [];
            customer.push("CustFirstName=" + this.props.customer.firstName);
            customer.push("CustLastName=" + this.props.customer.lastName);
            customer.push("CustEmail=" + this.props.customer.email);
            customer.push("CustCompany=" + this.props.customer.company);
            customer.push("CustPhone=" + this.props.customer.phone);
            customer.push("CustCountry=" + this.props.customer.country);
            customer.push("CustProject=" + this.props.customer.projectName);
            url+= "&" + customer.join("&");

        
            for(var i = 0; i < this.props.data.parameters.length; i++){
                url+= "&" + this.props.data.parameters[i].dwVar + "=" + (parseInt(this.props.data.parameters[i].choice + 1)); 
        }
                   
            console.log(url);
            var iframe = document.querySelector("#test_iframe");
            iframe.src = url //send current setup to second iframe tied to another instance of the DW stuff

            this.props.onClick('export_2');
        }else{
            document.querySelector('#cad_select').classList.add('dlg_error');
        }
    }
    render() {
        return (
            <div id="dlg_export_1" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Export CAD File</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_grey">
                            <div className="dlg_head">File format*</div>
                            <p>MTS offers a variety of CAD file format options.  However, MTS recommends SolidWorks for the best user experience for downloading a native file format</p>
                            <p id="cad_select">Please select file format:</p>
                            <div className="dlg_radio"><input type="radio" name="export_grp" value="1" />&nbsp;SolidWorks (v2019 SP5)</div>
                            <div className="dlg_radio"><input type="radio" name="export_grp" value="5" />&nbsp;Parasolid (.x_t)</div>
                            <div className="dlg_radio"><input type="radio" name="export_grp" value="6" />&nbsp;STEP (AP214)</div>
                        </div>
                        <div id="dlg_export_btn_2" className="dlg_btn" onClick={() => this.validateInput()}>DOWNLOAD</div>
                    </div>
                </div>
            </div>
        );
    }
}

export class ExportDialog_2 extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div id="dlg_export_2" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Export CAD File</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick('null')}>X</div>
                    </div>
                    <div className="dlg_content">
                        <p>We&#39;re processing your file for export.  When the file is ready for download, you will receive an email with a link to download your file.</p>
                        <div id="dlg_export_btn_3" className="dlg_btn" onClick={() => this.props.onClick('null')}>OK</div>
                    </div>
                </div>
            </div>
        );
    }
}
